import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from '../shared/app.service';
import { Observable } from 'rxjs';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';


@Component({
    //selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, AsyncPipe]
})
export class TestComponent implements OnInit {

  debuginfo$: Observable<any>;

  constructor(private http: HttpClient, private appService: AppService) {
    this.debuginfo$ = this.http.post<any>(this.appService.getUrl(`api/Test/GetDebugInfo`), {});
  }

  ngOnInit() {

  }

}
